import { Session } from "next-auth";
import { getSession } from "next-auth/react";
import { revalidate } from "../../common/constants";
import Newsletter from "../../view/components/Footer/components/Newsletter/Newsletter";
import Footer from "../../view/components/Footer/Footer";
import Header from "../../view/components/Header/Header";
import Utisci from "../../view/screens/Utisci/Utisci";
import {
    handleGetAllUtisci,
    returnUtisci,
    userHasUtisak,
} from "../api/utisak/getAll";

interface PocetnaProps {
    utisci: returnUtisci[];
}

export default function Pocetna({ utisci }: PocetnaProps) {
    return (
        <div className="relative bg-white">
            <Header />
            <Utisci recenzije={utisci} />
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}

export async function getServerSideProps({ req }) {
    const session: Session = await getSession({ req });
    const userId = session?.user.id;

    if (!userId) {
        return {
            props: { utisci: [] },
        };
    }
    const hasUtisak = await userHasUtisak({ userId });

    if (!hasUtisak) {
        return {
            props: { utisci: [] },
        };
    }

    const response = await handleGetAllUtisci();

    return {
        props: { utisci: response },
    };
}
